// Import required dependencies from Redux Toolkit and Axios
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosInstance from './AxiosInstance';
import { Method } from 'axios';

// Custom base query function that wraps axios instance for making HTTP requests
// Handles both successful responses and errors in a consistent format
const axiosBaseQuery = async ({ url, method, data }: { url: string; method: Method; data?: any }) => {
  try {
    const response = await axiosInstance({ url, method, data });
    return { data: response.data };
  } catch (error) {
    // Type assertion for error response structure
    const err = error as { response?: { status: number; data: any } };
    // Return error details including status code and response data
    return { error: { status: err.response?.status, data: err.response?.data } };
  }
};

// Create the base API instance using Redux Toolkit's createApi
const AppApi = createApi({
  // Unique key for storing API state in Redux store
  reducerPath: 'AppApi',
  // Use custom axios-based query function for all endpoints
  baseQuery: axiosBaseQuery,
  // Define tag types for cache invalidation and updates
  // - wialon: For Wialon-related data
  // - assignVehicle: For vehicle assignment operations
  // - monitoringMap: For map monitoring data
  tagTypes: ['wialon', 'assignVehicle', 'monitoringMap', 'availableVehicleStatistics'],
  // Empty endpoints object - endpoints will be injected by other files
  endpoints: () => ({}),
});

export default AppApi;
